<template>
  <div :class="$style.base" v-bind="$attrs">
    <slot />
  </div>
</template>

<script setup lang="ts">

interface DisplayTextProps {
  align?: 'start' | 'center'
}

const { align = 'start' } = defineProps<DisplayTextProps>()
</script>

<style module>
.base {
  text-align: v-bind('align')
}
</style>
